import SidebarItem from '.';
import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import SvgIcon from '@mui/material/SvgIcon';
import { forwardRef } from 'react';
import { NavLink } from 'react-router-dom';
import { Icons } from 'greener-ui-library';

const SidebarItemComponent = ({ className, onClick, path, children, sx }) => {
  if (!path) {
    return <ListItem sx={sx} className={className} children={children} onClick={onClick} />;
  }

  return (
    <ListItem
      sx={sx}
      className={className}
      children={children}
      component={forwardRef((props, ref) => (
        <NavLink end {...props} ref={ref} />
      ))}
      to={path}
    />
  );
};

export function MenuItemRoot(props) {
  const { path, handleClick, icon: Icon, isExpandable, isItemOpen, name, isActive } = props;

  return (
    <SidebarItemComponent
      sx={{
        cursor: 'pointer',
        color: (theme) => theme.palette.text.primary,
        '&.active': {
          background: (theme) => theme.palette.action.hover,
        },
      }}
      path={path}
      onClick={handleClick}
      isActive={isActive}
    >
      {Icon && (
        <ListItemIcon sx={{ marginRight: '1rem' }}>
          <SvgIcon style={{ fontSize: 20 }}>
            <Icon />
          </SvgIcon>
        </ListItemIcon>
      )}
      <ListItemText primary={name} inset={!Icon} />
      {isExpandable && !isItemOpen && <Icons.NavigateNext />}
      {isExpandable && isItemOpen && <Icons.ExpandMore />}
    </SidebarItemComponent>
  );
}

export function MenuItemChildren({ isExpandable, isItemOpen, items = [] }) {
  return (
    isExpandable && (
      <Collapse in={isItemOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {items.map((item, index) => (
            <SidebarItem {...item} key={index} />
          ))}
        </List>
      </Collapse>
    )
  );
}
